import React from 'react';
import {Twitter,Facebook,Linkedin} from 'react-bootstrap-icons';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './Footer.scss';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
	  padding: theme.spacing(2),
	},
	'& .MuiDialogActions-root': {
	  padding: theme.spacing(1),
	},
}));
  
const BootstrapDialogTitle = (props) => {
	const { children, onClose, ...other } = props;
  
	return (
	  <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
		{children}
		{onClose ? (
		  <IconButton
			aria-label="close"
			onClick={onClose}
			sx={{
			  position: 'absolute',
			  right: 8,
			  top: 8,
			  color: (theme) => theme.palette.grey[500],
			}}
		  >
			<CloseIcon />
		  </IconButton>
		) : null}
	  </DialogTitle>
	);
};
  
BootstrapDialogTitle.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.func.isRequired,
};

export default function Footer() {

	const [privacyOpen, setPrivacyOpen] = React.useState(false);
	const [cookiesOpen, setCookiesOpen] = React.useState(false);

	const handlePrivacyClickOpen = () => {
		setPrivacyOpen(true);
	};

	const handleCookiesClickOpen = () => {
		setCookiesOpen(true);
	};

	const handleClose = () => {
		setPrivacyOpen(false);
		setCookiesOpen(false);
	};

	return (
		<div className='footer-root'>
			<div className='copyright'>Copyright © Ugiat Technologies 2024</div>
			<div className='social'>
				<a href="https://www.twitter.com/ugiatTech"><div><Twitter /></div></a>
				<a href="https://www.facebook.com/ugiat"><div><Facebook /></div></a>
				<a href="https://www.linkedin.com/company/ugiat-technologies"><div><Linkedin /></div></a>
			</div>
			<div className='extra'>
				<span onClick={handlePrivacyClickOpen}>Privacy Policy </span>
				&amp;&nbsp;
				<span onClick={handleCookiesClickOpen}>Cookie Policy</span>
			</div>
			<BootstrapDialog
				onClose={handleClose}
				aria-labelledby="customized-dialog-title"
				open={cookiesOpen}
			>
				<BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
					COOKIE POLICY
				</BootstrapDialogTitle>
				<DialogContent dividers>
				<Typography gutterBottom>
						<b>What Are Cookies</b><br />
						As is common practice with almost all professional websites this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience. This page describes what information they gather, how we use it and why we sometimes need to store these cookies. We will also share how you can prevent these cookies from being stored however this may downgrade or 'break' certain elements of the sites functionality.
					</Typography>
					<Typography gutterBottom>
						<b>How We Use Cookies</b><br />
						We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use.
					</Typography>
					<Typography gutterBottom>
						<b>Disabling Cookies</b><br />
						You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of the this site. Therefore it is recommended that you do not disable cookies. This Cookies Policy was created with the help of the Cookies Policy Generator from CookiePolicyGenerator.com.
					</Typography>
					<Typography gutterBottom>
						<b>The Cookies We Set</b><br />
						Site preferences cookies: In order to provide you with a great experience on this site we provide the functionality to set your preferences for how this site runs when you use it. In order to remember your preferences we need to set cookies so that this information can be called whenever you interact with a page is affected by your preferences.
					</Typography>
					<Typography gutterBottom>
						<b>Third Party Cookies</b><br />
						This site may use Google Analytics which is one of the most widespread and trusted analytics solution on the web for helping us to understand how you use the site and ways that we can improve your experience. These cookies may track things such as how long you spend on the site and the pages that you visit so we can continue to produce engaging content.
					</Typography>
					<Typography gutterBottom>
						<b>More Information</b><br />
						Hopefully that has clarified things for you and as was previously mentioned if there is something that you aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact with one of the features you use on our site.

						For more general information on cookies, please read "Cookies" article from the Privacy Policy Generator.

						However if you are still looking for more information then you can contact us through one of our preferred contact methods:

						Email: ugiat@ugiat.com
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleClose}>
						Close
					</Button>
				</DialogActions>
			</BootstrapDialog>
			<BootstrapDialog
				onClose={handleClose}
				aria-labelledby="customized-dialog-title"
				open={privacyOpen}
			>
				<BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
					LEGAL AND PRIVACY
				</BootstrapDialogTitle>
				<DialogContent dividers>
					<Typography gutterBottom>
						<b>Purpose</b><br />
						This web site is managed by Ugiat Technologies that can be contacted 
						through the following mail: ugiat@ugiat.com
					</Typography>
					<Typography gutterBottom>
						<b>Intellectual Property</b><br />
						The content of this web site are mainly images, text, logos, graphics and other 
						computer applications. The right of these media files as well as the domain name 
						belong to the web site owner aside from some images obtained through public images 
						databases such as www.freeimages.com. This website is developed using Bootstrap that 
						works under the MIT License.
					</Typography>
					<Typography gutterBottom>
						<b>Personal Data Privacy</b><br />
						This website does not store any personal information execept some implicit data. It could 
						be the IP navigation address required to transmit the data for navigating through the web 
						as well as the information gathered by external applications as Google Analytics which is 
						out of our supervision.
					</Typography>
					<Typography gutterBottom>
						<b>Responsibilities</b><br />
						The web site owner do not assure the reliability, availability and continuity of the web 
						site contents arose from technical issues, security problems, hacking attacks, hosting 
						problems and other relevant causes out of the knowledge of the web site owner.
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleClose}>
						Close
					</Button>
				</DialogActions>
			</BootstrapDialog>
		</div>
	);

}
